"use strict";

const StreamsEsriDynamicMapLayer = function () {
  const layerName = "streamsEsriDynamicMap";
  const layerKey = "streamsEsriDynamicMapLayer";
  const esriKey = "soilImpervious";
  const esriLayer = "streams";

  var loadLayerListenersForMap = function (map, mapLayers, mapId) {
    var streamsEsriDynamicMapLayer = new EsriDynamicMapLayer(
      layerName,
      layerKey,
      esriKey,
      esriLayer,
    );
    streamsEsriDynamicMapLayer.loadToggledListenerForMap(map, mapLayers, mapId);
    streamsEsriDynamicMapLayer.loadTreeUpdateListenersForMap(map, mapLayers, mapId);
  };

  return {
    loadLayerListenersForMap,
  };
};

module.exports = StreamsEsriDynamicMapLayer();

const EsriDynamicMapLayer = require("../mapFunctions/esriDynamicMapLayer");
